import React from "react";

import {
  ConfirmPopupContainer,
  Image,
  Overlay,
  PopupDescription,
  PopupTitle,
  PopupContent,
  PopupEmotion,
} from "./styles";

function SuggestionPopup({
  imageSrc = "/images/lamp.png",
  imageAlt = "lamp",
  characterEmotion,
  title,
  description,
  styles,
  isNoOverlay = false,
}) {
  const { imageStyle, titleStyle } = styles || {};

  return (
    <>
      <ConfirmPopupContainer>
        <PopupContent>
          {characterEmotion ? (
            <PopupEmotion $characterEmotion={characterEmotion} />
          ) : (
            <Image $imageStyle={imageStyle} src={imageSrc} alt={imageAlt} />
          )}
          <PopupTitle $titleStyle={titleStyle}>{title}</PopupTitle>
          <PopupDescription>{description}</PopupDescription>
        </PopupContent>
      </ConfirmPopupContainer>
      {!isNoOverlay && <Overlay />}
    </>
  );
}

export default SuggestionPopup;
